import { Config, ErrorHandling, HtmlContentEditor, TranslationConfig, getjQuery, BaseDialog } from "@serenity-is/corelib";
import { gridDefaults } from "@serenity-is/sleekgrid";
import { getLanguageList } from "./Helpers/LanguageList";

import "jquery-ui-dist/jquery-ui";

Config.rootNamespaces.push('Dataman.Warehouse');
TranslationConfig.getLanguageList = getLanguageList;
HtmlContentEditor.CKEditorBasePath = "~/Serenity.Assets/Scripts/ckeditor/";
gridDefaults.useCssVars = false;

let $ = getjQuery();
if ($?.fn?.colorbox) {
    $.fn.colorbox.settings.maxWidth = "95%";
    $.fn.colorbox.settings.maxHeight = "95%";
}

window.onerror = ErrorHandling.runtimeErrorHandler;
window.addEventListener('unhandledrejection', ErrorHandling.unhandledRejectionHandler);


const observer = new MutationObserver(() => {
    $(".modal.show").each(function () {
        const modal = $(this);
        const dialog = modal.find(".modal-dialog");
        dialog.removeClass("modal-dialog-centered");

        if (dialog.data("drag-resize-enabled"))
            return;

        dialog.data("drag-resize-enabled", true);

        // Draggable
        dialog.draggable({
            handle: ".modal-header",
            cursor: "move",
            containment: "window"
        });

        const content = dialog.find(".modal-content");

        content.resizable({
            minWidth: 600,
            minHeight: 400,
            handles: "n,e,s,w,se,sw,ne,nw"
        });

        centerDialog(dialog);
    });
});

// Watch for modal open/close
observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class"]
});


function centerDialog(dialog: any) {
    const winW = $(window).width();
    const winH = $(window).height();

    const dlgW = dialog.outerWidth() || 0;
    const dlgH = dialog.outerHeight() || 0;

    dialog.css({
        position: "fixed",
        left: Math.max((winW - dlgW) / 2, 0),
        top: Math.max((winH - dlgH) / 2, 0)
    });
}